import { Currency } from '@bidelity/sdk'
/**
 * A currency is any fungible financial instrument on Ethereum, including Ether and all ERC20 tokens.
 *
 * The only instance of the base class `Currency` is Ether.
 */

const ETHER = Currency.ETHER
export { ETHER }
